<div class="mapview clearfix">
    <div class="mapouter">
        <div id="map-ex" style="height:100%;" #map>
        </div>
    </div>
    <div class="map-leftdiv" id="map-leftdiv">
            <div class="row">
                    <map-search-list [(source)]="propertiesTileCache" ></map-search-list>
                    <div *ngIf="propertiesCache?.length === 0" >
                        <div class="nodata">
                            <i class="fa fa-exclamation-triangle icon"></i>
                            <p>No data available</p>
                    </div>
                </div>
            </div>
    </div>
</div>

<ng-template #mapcard >
<app-map-property-card [property]="selectedProperty" (propertyPriorityChanged)="getPropertyPriorityChange()" ></app-map-property-card>
</ng-template>

<!-- <div class="pdetails">
<h2>{{ selectedProperty.PropertyName }}</h2>
<div class="row">
  <div class="col-md-6 col-sm-6 col-xs-6">
    <label class="greentextlabel">{{ selectedProperty.PropertyStatus }}</label>
  </div>
  <div class="col-md-6 col-sm-6 col-xs-6">
    <h3>{{(selectedProperty.Price && selectedProperty.IsShowPrice) ? '$ '+(selectedProperty.Price | number:0) : '-'}}</h3>
  </div>
</div>
<ul>
  <li>
    <p>Credit Rating</p>
    <h4>{{selectedProperty.RatingType}} {{selectedProperty.Rating ? '(' + selectedProperty.Rating +')' : ''}}</h4>
  </li>
  <li>
    <p>Remaining Term</p>
    <h4>{{ selectedProperty.RemainingTerm | yearsMonthConverter:true }}</h4>
  </li>
  <li>
    <p>Cap Rate</p>
    <h4>{{(selectedProperty.CapRate && selectedProperty.IsShowPrice) ? (selectedProperty.CapRate | number : '1.2-2') + '%' : '-'}}</h4>
  </li>
</ul>
</div> -->
